import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { BackendService } from './backend.service';

export type FeedbackCategory = 'bug' | 'idea' | 'agent' | 'other';

export interface ConversationTurn {
  role: 'user' | 'assistant';
  content: string;
}

export interface FeedbackRequest {
  category: FeedbackCategory;
  message: string;
  include_conversation: boolean;
  conversation?: ConversationTurn[];
  session_id?: string | null;
  agent_id?: string | null;
  agent_name?: string | null;
}

export interface FeedbackResult {
  saved: boolean;
  emailed: boolean;
  feedback_id?: string;
}

@Injectable({ providedIn: 'root' })
export class FeedbackService {
  constructor(
    private readonly http: HttpClient,
    private readonly backend: BackendService,
  ) {}

  /**
   * Submit one feedback entry to POST /agenthome/feedback. The API persists it
   * to the feedback table and emails the support DL. Errors are NOT swallowed
   * here — the caller distinguishes success (show the "sent" state) from
   * failure (keep the form open with an error).
   */
  submitFeedback(req: FeedbackRequest): Observable<FeedbackResult> {
    const url = this.backend.createUrl(environment.BASE_API.FEEDBACK);
    return this.http
      .post<{ success: boolean; body?: FeedbackResult }>(url, req)
      .pipe(
        map(res => ({
          saved: res?.body?.saved ?? !!res?.success,
          emailed: res?.body?.emailed ?? false,
          feedback_id: res?.body?.feedback_id,
        })),
      );
  }
}
